import React from "react";

import CalendarIcon from "@uui/Calendar";
import FileIcon from "@uui/File07";

import { SecondaryTextWithIcon } from "@app/analytics/Pulse/components/styles";
import { BulletedListItem } from "@app/analytics/Pulse/components/TopicsTable/styles";
import type { PulseClip } from "@app/analytics/Pulse/types";
import ROUTES from "@app/common/routes";

import { Column, Row } from "@rui/Stack";
import { Bold } from "@rui/styles";

const ListItem = ({
  item,
  textPrefix,
}: {
  item: PulseClip;
  textPrefix?: string;
}) => (
  <BulletedListItem>
    <Column>
      <span>
        {textPrefix ? <Bold>{textPrefix}</Bold> : null}
        {item.text}
      </span>
      <Row spacing={1.5} sx={{ pb: 0.5 }}>
        {item.startTime && (
          <SecondaryTextWithIcon
            Icon={CalendarIcon}
            sx={{ fontWeight: 400, fontSize: "0.625rem" }}
          >
            {item.startTime.toLocaleString({
              weekday: "short",
              month: "short",
              day: "numeric",
            })}
          </SecondaryTextWithIcon>
        )}
        {item.meetingTitle && (
          <SecondaryTextWithIcon
            Icon={FileIcon}
            href={ROUTES.meetingReportById(item.sessionId)}
            sx={{ fontWeight: 400, fontSize: "0.625rem" }}
          >
            {item.meetingTitle}
          </SecondaryTextWithIcon>
        )}
      </Row>
    </Column>
  </BulletedListItem>
);

export default ListItem;
